import React, { useEffect, useState } from 'react'
import RightArrow from '../../common/icons/right-arrow'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom';
import Apiauth from '../../../API/Apiauth';
import { loading, Updateloading } from '../../common/helpers/toastify';
import Editor from "../../common/editor/Editor.js";
// import exampleData from '../../common/editor/data/exampleData.js';
export default function AddBlock() {
    const { state } = useLocation()
    const { t } = useTranslation();
    const navigate = useNavigate()
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const [allValues, setAllValues] = useState({});
    const [data, setData] = useState();
    const [dataJson, setDataJson] = useState();
    const [dataJsonOnlyView, setDataJsonOnlyView] = useState();
    const menuTypeOptions = [
        { label: "Header", value: 1 },
        { label: "Footer", value: 2 }
    ]
    // Editor ref

    useEffect(() => {
        if (state?.pageId) {
            getPageDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    // Handler to handle button clicked


    const getPageDetails = async () => {
        try {
            let postdata = { "id": state?.pageId }
            let result = await Apiauth(postdata, `cms/get-block-view`)
            if (result.code === 200) {
                setAllValues(result?.data)
                setData(result?.data?.content);
                setDataJsonOnlyView(result?.data?.contentJson);
                setAllValues((state) => ({ ...state, menutype: menuTypeOptions[result?.data?.menutype - 1], file: { image: result?.data?.featuredImage } }))
            }
        }
        catch (err) {
            console.log(err, "Error")
        }
    }

    const handleSave = async () => {
        if (allValues?.title && data) {
            let GetloadingID = loading();

            try {
                console.log(allValues, "allValues");

                let postdata = {
                    "location_id": state?.location ? state?.location : "",
                    "content": data ? data : "",
                    "id": allValues.id,
                    "status": allValues.status ? 1 : 0,
                    "contentJson": dataJson ? dataJson : "",


                }

                let result = await Apiauth(postdata, `cms/block-edit`)
                if (result.code === 200) {
                    Updateloading(t, GetloadingID, t("Successfully edit"));

                } else {

                    Updateloading(t, GetloadingID, result?.message, 'error');
                }
            }
            catch (err) {
                console.log(err, "Error")
            }
        }
    }

    useEffect(() => {
        // Add label to the custom button
        const customButton = document.querySelector(".ql-customButton");
        if (customButton) {
            customButton.innerHTML = '<span style="font-size: 14px;"><i class="fa fa-code"></i></span>';
        }
    }, []);



    return (
        <div className='main-content-wrapper-body admincmsAddpage'>
            <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
                <div className="main-content-wrapper-body-top-bar-left">
                    <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0 cursor-pointer" onClick={() => navigate(-1)}>{t("HTML Blocks")} <RightArrow /> <span className="cursor-pointer">{t("Edit Block")}</span></h1>

                </div>
                <div className="main-content-wrapper-body-top-bar-right d-flex align-items-center">
                    <button className={"com-plus-text-btn text-white text-center fw-semibold d-flex align-items-center border-0 rounded-1 ms-3"} onClick={handleSave}>
                        <img className='w-100' src={base_assets + 'images/icons/white-save.png'} alt="" />
                    </button>
                </div>
            </div>
            <div className='row admincmsAddpage-content'>
                <div className='col-md-9 admincmsAddpage-content-section'>
                    <div className="col-md-12 bg-white p-2">
                        <div className="v3-input-group">
                            <label className="v3-input-group-label">{allValues?.title}</label>
                        </div>
                    </div>
                    <div className="col-md-12 bg-white p-2">
                        <div className="v3-input-group">
                            <label className="v3-input-group-label">{t("Description")}<span className='text-danger'> *</span></label>
                            <div className="app-content">
                                {console.log(dataJson, "PPPPPPPPPPPPP")}
                                <Editor dataJsonOnlyView={dataJsonOnlyView} dataJson={dataJson} setData={setData} setDataJson={setDataJson} />

                            </div>
                        </div>
                    </div>

                </div>
                {/* section 2 */}
                <div className='col-md-3 gap admincmsAddpage-content-section'>
                    <div className="col-md-12 bg-white p-2 admincmsAddpage-content-section-inputfield">
                        <div className="v3-input-group">

                            <div className="form-check form-switch ps-0 text-nowrap align-items-center d-flex justify-content-between">
                                <label className="v3-input-group-label">{t("Status")}</label>
                                <input className="form-check-input float-none ms-0 me-2 cursor-pointer mb-0" type="checkbox"
                                    onChange={(e) => setAllValues((state) => ({ ...state, status: !state.status }))}
                                    checked={allValues?.status} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
